"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Stepper = void 0;
var solid_1 = require("@heroicons/react/20/solid");
var react_1 = __importStar(require("react"));
var Stepper = /** @class */ (function (_super) {
    __extends(Stepper, _super);
    function Stepper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderEachSteps = function (eachStep, index) {
            var defaultStepContainerCss = "absolute top-4 left-4 -ml-px mt-0.5 h-full w-0.5 ";
            var defaultSpanContainerCss = "relative z-10 flex h-8 w-8 items-center justify-center rounded-full border ";
            var defaultSpanCss = "h-2.5 w-2.5 rounded-full ";
            var defaultTextCss = "text-sm font-medium ";
            var activeStepContainerCSS = "".concat(_this.props.light ? "bg-primary-300" : "bg-primary-600");
            var activeSpanContainerCSS = "".concat(_this.props.light
                ? "group-hover:bg-gray-200"
                : "group-hover:bg-primary-800");
            var activeTextCSS = _this.props.light ? "text-white" : "text-gray-500";
            if (index < _this.props.stepIndex) {
                var spanContainerCSS = _this.props.disabled
                    ? ""
                    : activeSpanContainerCSS;
                defaultStepContainerCss += activeStepContainerCSS;
                defaultSpanContainerCss += "".concat(_this.props.light ? "bg-white" : "bg-primary-600", " ").concat(spanContainerCSS);
                if (_this.props.light) {
                    defaultTextCss += "text-white";
                }
            }
            else if (index === _this.props.stepIndex) {
                defaultStepContainerCss += activeStepContainerCSS;
                defaultSpanContainerCss += " border-primary-600 bg-white";
                defaultSpanCss += "bg-primary-600";
                defaultTextCss += activeTextCSS;
            }
            else {
                defaultStepContainerCss += "bg-gray-300";
                defaultSpanContainerCss += "border-gray-300 bg-white  ".concat(_this.props.disabled ? "" : "group-hover:border-gray-400");
                defaultSpanCss += "bg-transparent ".concat(_this.props.disabled ? "" : "group-hover:bg-gray-300", " ");
                defaultTextCss += activeTextCSS;
            }
            return (react_1.default.createElement(react_1.default.Fragment, null,
                index !== _this.props.steps.length - 1 && (react_1.default.createElement("div", { className: defaultStepContainerCss, "aria-hidden": "true" })),
                react_1.default.createElement("div", { className: "group relative flex items-start ".concat(_this.props.disabled ? "" : "cursor-pointer"), onClick: _this.props.disabled
                        ? function () { }
                        : _this.props.onChange.bind(_this, index) },
                    react_1.default.createElement("span", { className: "flex h-9 items-center", "aria-hidden": "true" },
                        react_1.default.createElement("span", { className: defaultSpanContainerCss }, index < _this.props.stepIndex ? (react_1.default.createElement(solid_1.CheckIcon, { className: "h-5 w-5 ".concat(_this.props.light ? "text-primary-600" : "text-white"), "aria-hidden": "true" })) : (react_1.default.createElement("span", { className: defaultSpanCss })))),
                    react_1.default.createElement("span", { className: "ml-4 flex min-w-0 flex-col" },
                        react_1.default.createElement("span", { className: defaultTextCss }, eachStep.title),
                        eachStep.description && (react_1.default.createElement("span", { className: "text-sm ".concat(_this.props.light ? "text-primary-100" : "text-gray-500") }, eachStep.description))))));
        };
        return _this;
    }
    Stepper.prototype.render = function () {
        var _this = this;
        if (this.props.horizontal) {
            return (react_1.default.createElement("div", { className: this.props.className },
                react_1.default.createElement("div", { className: "overflow-hidden rounded-full bg-gray-200" },
                    react_1.default.createElement("div", { className: "h-2 rounded-full bg-primary-600", style: {
                            width: ((this.props.stepIndex + 1) / this.props.steps.length) * 100 +
                                "%",
                        } })),
                react_1.default.createElement("div", { className: "mt-6 flex justify-between text-sm font-medium text-gray-600" }, this.props.steps.map(function (eachStep, index) {
                    return (react_1.default.createElement("div", { className: "flex flex-col ".concat(_this.props.disabled ? "" : "cursor-pointer"), onClick: _this.props.disabled
                            ? function () { }
                            : _this.props.onChange.bind(_this, index) },
                        react_1.default.createElement("div", { className: "text-primary-600 ".concat(index > 0
                                ? index === _this.props.steps.length - 1
                                    ? "text-right"
                                    : "text-center"
                                : "") }, eachStep.title)));
                }))));
        }
        else {
            return (react_1.default.createElement("nav", { className: this.props.className, "aria-label": "Progress" },
                react_1.default.createElement("ol", { className: "overflow-hidden" }, this.props.steps.map(function (step, index) { return (react_1.default.createElement("li", { key: step.title, className: (index !== _this.props.steps.length - 1 ? "pb-10" : "") +
                        " relative" }, _this.renderEachSteps(step, index))); }))));
        }
    };
    return Stepper;
}(react_1.Component));
exports.Stepper = Stepper;
//# sourceMappingURL=index.js.map